export default function Eligibility() {
  const criteria = [
    { icon: 'ri-user-line', text: '年齡：18–25 歲' },
    { icon: 'ri-home-heart-line', text: '家庭經濟資源相對弱勢' },
    { icon: 'ri-lightbulb-line', text: '具備學習動機與明確目標' },
    { icon: 'ri-shield-star-line', text: '展現責任感、韌性與品格' },
    { icon: 'ri-hand-heart-line', text: '願意投入社會服務或公益行動' }
  ];

  return (
    <section id="eligibility" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-sm text-gray-500 mb-6 tracking-wider">ELIGIBILITY</p>
            <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
              獎助對象
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              少華獎主要支持具備潛力、品格與責任感,但因環境限制而缺乏發展機會的台灣青年。我們特別鼓勵來自偏鄉、單親家庭、經濟困難或教育資源不足環境的青年申請。
            </p>
            <div className="space-y-4">
              {criteria.map((item, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-[#F4A261]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#F4A261] text-xl w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <p className="text-base text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden h-[600px]">
            <img
              src="https://public.readdy.ai/ai/img_res/d10cb4faa9e222c4411a2cdd4f7491c4.jpg"
              alt="獎助對象"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
